import { type StateCreator } from 'zustand';

import { type MiddlewareType, type SearchStore } from '../SearchStoreProvider';

export type ShopState = {
  shopIds?: string[];
  masterDataShopIds?: string[];
  masterDataLiPaIds?: string[];
};

type ShopActions = {
  setShopIds: (shopIds?: string[]) => void;
  setMasterDataShopIds: (masterDataShopIds?: string[]) => void;
  setMasterDataLiPaIds: (masterDataLiPaIds?: string[]) => void;
  resetShopState: () => void;
};

export type ShopStore = ShopState & ShopActions;

export const defaultShopState: Readonly<ShopState> = {
  shopIds: undefined,
  masterDataShopIds: undefined,
  masterDataLiPaIds: undefined,
};

export const createShopSlice: StateCreator<SearchStore, MiddlewareType, [], ShopStore> = (set) => ({
  ...defaultShopState,
  setShopIds: (shopIds?: string[]) => {
    set({ shopIds, page: 1 }, undefined, 'setShopIds');
  },
  setMasterDataShopIds: (masterDataShopIds?: string[]) => set({ masterDataShopIds }, undefined, 'setMasterDataShopIds'),
  setMasterDataLiPaIds: (masterDataLiPaIds?: string[]) => {
    set({ masterDataLiPaIds, page: 1 }, undefined, 'setMasterDataLiPaIds');
  },
  resetShopState: () => set(defaultShopState, undefined, 'resetShopState'),
});
